var getBuiltIn = require('../internals/get-built-in');

module.exports = getBuiltIn('navigator', 'userAgent') || '';



//////////////////
// WEBPACK FOOTER
// ./~/handsontable/~/core-js/internals/user-agent.js
// module id = Eaol
// module chunks = 0